import { render, staticRenderFns } from "./WrapperFromVaccinePricingAndDosesDistributionCampaignEdit.vue?vue&type=template&id=5d8787ee&"
import script from "./WrapperFromVaccinePricingAndDosesDistributionCampaignEdit.vue?vue&type=script&lang=js&"
export * from "./WrapperFromVaccinePricingAndDosesDistributionCampaignEdit.vue?vue&type=script&lang=js&"
import style0 from "./WrapperFromVaccinePricingAndDosesDistributionCampaignEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports